export type ConcurrencyGate = <T>(task: () => Promise<T>) => Promise<T>;

export const createConcurrencyGate = (limit: number): ConcurrencyGate => {
  let running = 0;
  const waiting: (() => void)[] = [];

  return async task => {
    if (running >= limit) await new Promise<void>(resolve => waiting.push(resolve));
    else running++;

    try {
      return await task();
    } finally {
      // The freed slot is handed to the next waiter rather than released, so a caller arriving in the
      // same tick as the hand-over cannot take it as a spare one and push past the limit.
      const next = waiting.shift();

      if (next) next();
      else running--;
    }
  };
};
